import { Row } from "antd";
import docImg from "../../../images/document.svg";

export const EmptyList = () => {
  return (
    <Row className="w-100 justify-center h-100 align-center">
      <Row className="flex-column align-center justify-center">
        <img src={docImg} alt="doc" />
        <p className="my-0 text">No documents yet</p>
      </Row>
    </Row>
  );
};
